import { RuleScopeProperty, RuleTypeFeature } from '../consts';

const RuleKeyAdd = 'feature-add';
const RuleKeyRemove = 'feature-remove';

const allowedKeys = [ RuleKeyAdd, RuleKeyRemove ];

const allowedKeyScopes = {
    [ RuleKeyAdd ]: [ RuleScopeProperty ],
    [ RuleKeyRemove ]: [ RuleScopeProperty ]
};

const template = {
    feature: null,
    key: null,
    type: RuleTypeFeature,
    scope: ''
};

/**
 * @description
 * @param {String} feature - the feature name to create the rule for
 * @param {String} key - the key of the rule, one of allowedKeys
 * @returns
 */
const makeFeatureRule = ( base ) => {
    let rule = null;

    if ( !base.feature ) {
        return {
            rule: rule,
            error: new Error( 'invalid feature' )
        };
    }

    if ( !allowedKeys.includes( base.key ) ) {
        return {
            rule: rule,
            error: new Error( `"${base.key}" is not a valid rule key` )
        };
    }

    if ( !( 'scope' in base ) ) {
        return {
            rule: rule,
            error: new Error( 'missing required key scope' )
        };
    }

    if ( !allowedKeyScopes[ base.key ].includes( base.scope ) ) {
        return {
            rule: rule,
            error: new Error( `scope "${base.scope}" is not supported for key ${base.key}` )
        };
    }

    if ( !( 'createdBy' in base ) ) {
        return {
            rule: rule,
            error: new Error( 'missing required key createdBy' )
        };
    }

    rule = {
        feature: base.feature,
        key: base.key,
        createdBy: base.createdBy,
        scope: base.scope
    };

    return {
        rule: Object.assign( {}, template, rule ),
        error: null
    };
};

export {
    makeFeatureRule,
    RuleKeyAdd,
    RuleKeyRemove
};



// WEBPACK FOOTER //
// ./src/components/property-qc/rules/feature.js